import React, { useState } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { storeActions } from '../../store/configureStore';

const ImmoscoutAPI = ({ oggetto, startEditOggetto }) => {
  const [spinner, useSpinner] = useState(false);

  //Per inviare i dati dell'immobile
  const is24api = () => {
    useSpinner(true);

    axios
      .post(`${process.env.HEROKU_API}/property`, oggetto)
      .then(function (response) {
        startEditOggetto(oggetto.id, {
          ...oggetto,
          is24id: response.data['common.messages'][0].message.id,
        });
        useSpinner(false);
      })
      .catch(function (error) {
        console.log(error);
        useSpinner(false);
      });
  };

  const imgUpload = () => {
    const imageFile = new FormData();
    imageFile.append('file', oggetto.downloadURLsCover[0]);
    axios
      .post(`${process.env.HEROKU_API}/image`, {
        img: oggetto.downloadURLsCover[0], //imageFile,
        // token: localStorage.getItem('token'),
        is24id: oggetto.is24id,
      })

      .then((response) => console.log(response.data));
  };

  const btnColor = oggetto.is24id ? 'disabled' : 'green';
  return (
    <div>
      {spinner ? (
        <img className='loader__image' src='/images/loader.gif' />
      ) : (
        <div>
          <button className={`btn ${btnColor}`} onClick={is24api}>
            Export to IS24
          </button>
        </div>
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  startEditOggetto: (id, oggetto) =>
    dispatch(
      storeActions
        .find((action) => action.label === 'oggetti')
        .startEditAction(id, oggetto)
    ),
});

export default connect(
  undefined,
  mapDispatchToProps
)(withTranslation()(ImmoscoutAPI));



// WEBPACK FOOTER //
// ./src/components/oggetti/ImmoscoutAPI.js